<div class="promotional">
  <main class="main programme-landing" data-testid="landing-white-label">
    <wil-landing-hero (ctaClicked)="trackCta($event)"></wil-landing-hero>
    <wil-landing-static-sections></wil-landing-static-sections>
    <wil-landing-programme-example
      [delegationCategories]="delegationCategories"
      [conversationCategories]="conversationCategories"
    ></wil-landing-programme-example>
    <wil-landing-commercial-sections></wil-landing-commercial-sections>
    <wil-landing-faq [items]="faqItems" [expandedItems]="expandedFaqItems()" (itemToggled)="toggleFaq($event)"></wil-landing-faq>
    <wil-landing-enquiry></wil-landing-enquiry>
  </main>
</div>
